import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService, IBreadcrumbRoute } from '../../core/breadcrumbs.service';
import { LangService } from '../../core/lang.service';
import { LoginGuardService } from '../../api/login-guard.service';
import { AccountType } from '../../constants/account-types';

export const LEARNMORE_SECTION_TESTADMIN = 'testadmin';
@Component({
  selector: 'proctor-learnmore',
  templateUrl: './proctor-learnmore.component.html',
  styleUrls: ['./proctor-learnmore.component.scss']
})
export class ProctorLearnmoreComponent implements OnInit {

  breadcrumbPre:IBreadcrumbRoute[];
  learmoreSection = LEARNMORE_SECTION_TESTADMIN;
  accountType = AccountType.TEST_ADMIN;

  constructor(
    public langService:LangService,
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService
  ) { }

  ngOnInit() {
    this.loginGuard.deactivate();
    this.breadcrumbPre = [
      this.breadcrumbsService.TESTADMIN_LANDING(),
      this.breadcrumbsService.TESTADMIN_LEARN(),
    ];
  }
  getLearnmoreSection(){
    return this.breadcrumbsService.learnMoreSection.TESTADMIN;
  }
  
}
